export interface ITransaction {
  effectiveDate: string;
  transactionType: string;
}

export interface IRating {
  ratingCode: string;
  ratingDescription: string,
  ratingEffectiveDate: string,
  tradeCertificationDate?: string;
  transactions: ITransaction[]
}

export interface IRatingsData {
  totalCurrentRatings: number;
  currentRatings: IRating[];
  droppedRatings: IRating[];
}

export const CurrentRatingsDataAutomation = {
  table: 'curr-ratings-table',
  header: 'curr-header',
  columns: ['curr-description-header', 'effective-date-header', 'trade-cert-header'],
  collapsibleRow: 'curr-row-#',
  noRecords: 'curr-no-record',
}

export const DroppedRatingsDataAutomation = {
  table: 'drop-ratings-table',
  header: 'drop-header',
  columns: ['drop-description-header', 'trans-date-header'],
  collapsibleRow: 'drop-row-#',
  noRecords: 'drop-no-record',
}